module.exports = __webpack_public_path__ + "static/media/designPatent_30-1040513.bc02a2d1.png";